<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Datatable from "@/router/layouts/table-datatable";
import Pagination from "@/router/layouts/table-pagination";
import axios from "axios";
import Swal from "sweetalert2";
import _ from "lodash";

export default {
  page: {
    title: "Starter Page",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, Datatable, Pagination },
  data() {
    let sortOrders = []; // select sortOrder

    // definisi kolom yang dipakai
    let columns = [
      {
        width: "50px",
        label: "No",
        name: "-",
      },
      {
        width: "auto",
        label: "Nama",
        name: "-",
      },
      {
        width: "auto",
        label: "Jabatan Asesmen",
        name: "-",
      },
      {
        width: "auto",
        label: "Unit",
        name: "-",
      },
      {
        width: "auto",
        label: "Kode Kompetensi",
        name: "-",
      },
      {
        width: "auto",
        label: "Kompetensi",
        name: "-",
      },
      {
        width: "auto",
        label: "Level",
        name: "-",
      },
      {
        width: "auto",
        label: "Jenis Kompetensi",
        name: "-",
      },
      {
        width: "auto",
        label: "Skor",
        name: "-",
      },
      {
        width: "auto",
        label: "Kategori",
        name: "-",
      },
      {
        width: "auto",
        label: "Klasifikasi",
        name: "-",
      },
      {
        width: "auto",
        label: "Kode Profesi",
        name: "-",
      },
      {
        width: "auto",
        label: "Nama Profesi",
        name: "-",
      },
      {
        width: "auto",
        label: "Kode Dahan",
        name: "-",
      },
      {
        width: "auto",
        label: "Dahan Profesi",
        name: "-",
      },
    ];

    // cek sorting
    columns.forEach((column) => {
      sortOrders[column.name] = -1;
    });

    // Get hak akses
    const menu = "Report Success Profile";

    return {
      title: menu,
      loadingTable: false,
      columns: columns,
      sortKey: "nama",
      sortOrders: sortOrders,
      currentTablePage: "",
      tableData: [],
      tableFilter: {
        page: 1,
        draw: 0,
        per_page: 10,
        search: "",
        column: "nama",
        dir: "asc",
        nama: "",
        jabatan_asesmen: "",
        kompetensi: "",
        level: "Semua Level",
        filter_status: "all", // untuk filtering data
      },
      pagination: {
        lastPage: "",
        currentPage: "",
        total: "",
        lastPageUrl: "",
        nextPageUrl: "",
        prevPageUrl: "",
        from: "",
        to: "",
        links: "",
      },
      optionFilterLevel: [],
    };
  },
  methods: {
    getLevelKompetensi() {
      axios
        .get(
          process.env.VUE_APP_BACKEND_URL_VERSION + "master/level-kompetensi",
          {
            headers: {
              Authorization: "Bearer " + localStorage.access_token,
            },
          }
        )
        .then((response) => {
          this.optionFilterLevel = response.data.data;
          this.optionFilterLevel.unshift({
            nama_level: "Semua Level",
          });
        })
        .catch((error) => {
          console.error(error);
        });
    },
    async getDataTable(resetPage = true) {
      this.tableFilter.page = resetPage ? 1 : this.tableFilter.page;
      this.loadingTable = true;
      this.tableData = [];
      const config = {
        method: "get",
        url: `${process.env.VUE_APP_BACKEND_URL_VERSION}report-success-profile`,
        params: this.tableFilter,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        },
      };
      await axios(config)
        .then((response) => {
          if (response.data.meta.code == 200) {
            this.tableData = response.data.data.data;
            this.currentTablePage = response.data.data.current_page;
            this.loadingTable = false;
            this.configPagination(response.data.data);
          } else {
            this.loadingTable = false;
            Swal.fire({
              icon: "error",
              title: "Error",
              text: response.data.meta.message,
            });
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
          this.loadingTable = false;
        });
    },
    configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last_page_url;
      this.pagination.nextPageUrl = data.next_page_url;
      this.pagination.prevPageUrl = data.prev_page_url;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
      this.pagination.links = data.links;
    },
    sortBy(key) {
      this.sortKey = key;
      this.sortOrders[key] = this.sortOrders[key] * -1;
      this.tableFilter.column = key;
      this.tableFilter.dir = this.sortOrders[key] === 1 ? "asc" : "desc";
      this.getDataTable();
    },
    getIndex(array, key, value) {
      return array.findIndex((i) => i[key] == value);
    },
    toPage(url) {
      let link = new URLSearchParams(url.split("?")[1] || "");
      this.tableFilter.page = link.get("page");
      // this.tableFilter.per_page = link.get('per_page');
      this.getDataTable(false);
    },
    exportData() {
      const filteredParams = Object.fromEntries(
        Object.entries(this.tableFilter).filter(
          ([key, value]) => key !== null && value !== null
        )
      );
      let params = new URLSearchParams(filteredParams).toString();
      window.open(
        process.env.VUE_APP_BACKEND_URL_VERSION +
          "export-excel/report-success-profile?" +
          params
      );
    },
  },
  mounted() {
    this.getDataTable();
    this.getLevelKompetensi();
    this.filterData = _.debounce(this.getDataTable.bind(this), 500);
  },
};
</script>
<template>
  <Layout>
    <PageHeader :title="title" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-12 d-flex justify-content-between">
                <h4 class="card-title">Report Analisa Soal</h4>
                <button class="btn btn-success btn-sm" @click="exportData()">
                  <i class="fa fa-file-excel"></i> Export Excel
                </button>
              </div>
              <div class="col-lg-12">
                <hr />
                <div class="row">
                  <div class="col-md-3 form-group">
                    <label for="">Nama</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="tableFilter.nama"
                      placeholder="Filter Nama"
                      @input="filterData"
                    />
                  </div>
                  <div class="col-md-3 form-group">
                    <label for="">Jabatan Asesmen</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="tableFilter.jabatan_asesmen"
                      placeholder="Filter Jabatan Asesmen"
                      @input="filterData"
                    />
                  </div>
                  <div class="col-md-3 form-group">
                    <label for="">Kompetensi</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="tableFilter.kompetensi"
                      placeholder="Filter Kompetensi"
                      @input="filterData"
                    />
                  </div>
                  <div class="col-md-3 form-group">
                    <label for="">Level</label>
                    <v-select
                      id="parent_menu"
                      class="style-chooser"
                      :options="optionFilterLevel"
                      :reduce="(item) => item.nama_level"
                      label="nama_level"
                      v-model="tableFilter.level"
                      placeholder="Filter Level"
                      @update:modelValue="getDataTable()"
                    />
                  </div>
                </div>
                <hr />
              </div>
              <div class="col-md-12 mb-2">
                <div class="row">
                  <div class="col-md-4">
                    <table>
                      <tr>
                        <td>Show</td>
                        <td>
                          <select
                            class="form-control form-control-sm"
                            v-model="tableFilter.per_page"
                            @change="getDataTable()"
                          >
                            <option value="10" selected>10</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                            <option value="200">200</option>
                            <option value="500">500</option>
                          </select>
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
              <datatable
                :columns="columns"
                :sortKey="sortKey"
                :sortOrders="sortOrders"
                @sort="sortBy"
                :class="'table align-middle table-nowrap'"
              >
                <tbody>
                  <tr v-if="loadingTable">
                    <td colspan="99" class="text-center">
                      <i class="fas fa-spinner fa-spin"></i> Loading...
                    </td>
                  </tr>
                  <tr v-else-if="tableData.length == 0">
                    <td colspan="99" class="text-center">
                      Data tidak tersedia
                    </td>
                  </tr>
                  <tr v-else v-for="(row, key) in tableData" :key="key">
                    <td>
                      <span v-if="key + 1 == 10">
                        {{ currentTablePage }}0.
                      </span>
                      <span v-else>
                        {{
                          currentTablePage - 1 != 0
                            ? currentTablePage - 1 + `${key + 1}`
                            : `${key + 1}`
                        }}.
                      </span>
                    </td>
                    <td>
                      {{ row.nama ?? "-" }}
                    </td>
                    <td>
                      {{ row.jabatan_asesmen ?? "-" }}
                    </td>
                    <td>
                      {{ row.unit ?? "-" }}
                    </td>
                    <td>
                      {{ row.kode_tes ?? "-" }}
                    </td>
                    <td>
                      {{ row.nama_kompetensi ?? "-" }}
                    </td>
                    <td>
                      {{ row.nama_level ?? "-" }}
                    </td>
                    <td>
                      {{ row.jenis_kompetensi ?? "-" }}
                    </td>
                    <td>
                      {{ row.prosentase_skor ?? "-" }}
                    </td>
                    <td>
                      {{ row.kategori ?? "-" }}
                    </td>
                    <td>
                      {{ row.klasifikasi ?? "-" }}
                    </td>
                    <td>
                      {{ row.kode_profesi ?? "-" }}
                    </td>
                    <td>
                      {{ row.nama_profesi ?? "-" }}
                    </td>
                    <td>
                      {{ row.kode_dahan ?? "-" }}
                    </td>
                    <td>
                      {{ row.nama_dahan ?? "-" }}
                    </td>
                  </tr>
                </tbody>
              </datatable>
            </div>
            <pagination :pagination="pagination" @to-page="toPage"></pagination>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
